import * as React from "react";
import {
    AddBox,
    Dashboard,
    EventNote,
    HeadsetMic,
    InsertChart,
    LegendToggleOutlined,
    LiveTv,
    Schedule,
    School,
    SummarizeOutlined,
    VpnKey,
    Webhook,
} from "@mui/icons-material";
import { navigate } from "@reach/router";
import styled from "styled-components";
import SidebarItem from "./SidebarItem";
import { GetOrganizationBasics_organization } from "../GetStarted/__generated__/GetOrganizationBasics";
import AuthService from "../../auth/AuthService";

interface Props {
    organization: GetOrganizationBasics_organization;
    onCloseSidebar: () => void;
}

const Wrapper = styled.div`
    display: flex;
    height: 75%;
    flex-direction: column;
    justify-content: space-between;
`;

const DevelopersItems = styled.div`
    background-color: white;
    border-radius: 15px;
    padding: 10px 10px 5px 10px;
    margin-bottom: 15px;
    margin-top: 40px;
`;

export function onSidebarNavigate(organizationId: string, part: string, closeSidebar: () => void) {
    closeSidebar();
    navigate(`/app/${organizationId}/${part}`);
}

export const GHANA_ORG_ID = "b8aad5e8-524f-4293-8aca-e9bffeb52faf";
export const NFL_ORG_ID = "b6810903-7d31-4333-9cf4-c7f480f665da";
export const SIS_ORG_ID = "ad7fc78f-8d11-4e75-82ac-0335ae4ab720";

function OrganizationSidebar({ organization, onCloseSidebar }: Props) {
    function onNavigate(path: string) {
        onSidebarNavigate(organization.organizationId, path, onCloseSidebar);
    }

    return (
        <>
            <Wrapper>
                <div>
                    <SidebarItem
                        text="Dashboard"
                        icon={
                            <Dashboard
                                style={{ color: window.location.href.includes("dashboard") ? "black" : "#787878" }}
                            />
                        }
                        onClick={() => onNavigate(`dashboard`)}
                        selected={window.location.href.includes("dashboard")}
                    />
                    <SidebarItem
                        text="Channels"
                        icon={
                            <LiveTv
                                style={{ color: window.location.href.includes("channels") ? "black" : "#787878" }}
                            />
                        }
                        onClick={() => onNavigate(`channels`)}
                        selected={window.location.href.includes("channels")}
                    />
                    <SidebarItem
                        text="Create channel"
                        icon={<AddBox style={{ color: "#787878" }} />}
                        onClick={() => onNavigate(`channels/create`)}
                    />
                    <SidebarItem
                        text="Schedulers"
                        icon={
                            <Schedule
                                style={{ color: window.location.href.includes("schedulers") ? "black" : "#787878" }}
                            />
                        }
                        onClick={() => onNavigate(`schedulers`)}
                        selected={window.location.href.includes("schedulers")}
                    />
                    {organization.organizationId !== GHANA_ORG_ID && (
                        <SidebarItem
                            text="Usage"
                            icon={
                                <InsertChart
                                    style={{
                                        color:
                                            window.location.href.includes("usage") &&
                                            !window.location.href.includes("channels")
                                                ? "black"
                                                : "#787878",
                                    }}
                                />
                            }
                            onClick={() => onNavigate(`usage`)}
                            selected={
                                window.location.href.includes("usage") && !window.location.href.includes("channels")
                            }
                        />
                    )}
                    {organization.organizationId === SIS_ORG_ID && AuthService.isAdmin() && (
                        <SidebarItem
                            text="On Prem monitoring"
                            icon={
                                <LegendToggleOutlined
                                    style={{
                                        color: window.location.href.includes("on-prem-monitoring")
                                            ? "black"
                                            : "#787878",
                                    }}
                                />
                            }
                            onClick={() => onNavigate(`on-prem-monitoring`)}
                            selected={window.location.href.includes("on-prem-monitoring")}
                        />
                    )}

                    {organization.quotas.maxReportsPerDay > 0 && (
                        <SidebarItem
                            text="Reporting"
                            icon={
                                <SummarizeOutlined
                                    style={{
                                        color: window.location.href.includes("reporting") ? "black" : "#787878",
                                    }}
                                />
                            }
                            onClick={() => onNavigate(`reporting`)}
                            selected={window.location.href.includes("reporting")}
                        />
                    )}
                    {organization.currentContract?.hasAccessToSD === true && (
                        <SidebarItem
                            text="Service Desk"
                            icon={<HeadsetMic style={{ color: "#787878" }} />}
                            onClick={() => window.open(`https://opentelly.atlassian.net/servicedesk/customer/portal/1`)}
                            selected={false}
                        />
                    )}
                </div>
                <DevelopersItems>
                    <div style={{ fontWeight: "bold", marginBottom: "5px" }}>Developers</div>
                    <SidebarItem
                        text="Tokens"
                        icon={
                            <VpnKey style={{ color: window.location.href.includes("tokens") ? "black" : "#787878" }} />
                        }
                        onClick={() => onNavigate(`tokens`)}
                        selected={window.location.href.includes("tokens")}
                    />
                    <SidebarItem
                        text="Webhooks"
                        icon={
                            <Webhook
                                style={{ color: window.location.href.includes("webhooks") ? "black" : "#787878" }}
                            />
                        }
                        onClick={() => onNavigate(`webhooks`)}
                        selected={window.location.href.includes("webhooks")}
                    />
                    <SidebarItem
                        text="Events"
                        icon={
                            <EventNote
                                style={{ color: window.location.href.includes("events") ? "black" : "#787878" }}
                            />
                        }
                        onClick={() => onNavigate(`events`)}
                        selected={window.location.href.includes("events")}
                    />
                    <SidebarItem
                        text="Documentation"
                        icon={<School style={{ color: "#787878" }} />}
                        // eslint-disable-next-line no-undef
                        onClick={() => window.open(`https://optiview.dolby.com/docs/theolive/`)}
                    />
                </DevelopersItems>
            </Wrapper>
        </>
    );
}

export default OrganizationSidebar;
